import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apiRequest } from "../../lib/request"
import { validateUploadFile } from "../../lib/constants/uploadTypes"

export const uploadMediaFiles = createAsyncThunk(
  "mediaUpload/uploadFiles",
  async ({ clientId, files }, { rejectWithValue }) => {
    try {
      for (const file of files) {
        const err = validateUploadFile(file)
        if (err) throw new Error(err)
      }

      // Upload logic
      const formData = new FormData()
      files.forEach(f => formData.append("files", f))

      const url = `media/clients/${clientId}`
      const response = await apiRequest(url, {
        method: "POST",
        body: formData,
      })

      return response
    } catch (error) {
      console.error("[Upload error]:", error)

      let errorMessage = error.message || "Upload failed. Please try again."

      return rejectWithValue(errorMessage)
    }
  }
)


const mediaUploadSlice = createSlice({
  name: "mediaUpload",
  initialState: {
    uploadedFiles: [],
    uploadProgress: {},
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    resetUploadState: (state) => {
      state.uploadedFiles = []
      state.uploadProgress = {}
      state.status = "idle"
      state.error = null
    },
    updateUploadProgress: (state, action) => {
      const { fileId, progress } = action.payload
      state.uploadProgress[fileId] = progress
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadMediaFiles.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(uploadMediaFiles.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.uploadedFiles = action.payload
        state.uploadProgress = {}
      })
      .addCase(uploadMediaFiles.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
        state.uploadProgress = {}
      })
  },
})

export const { resetUploadState, updateUploadProgress } = mediaUploadSlice.actions
export default mediaUploadSlice.reducer
